import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import { useState } from "preact/hooks"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const { removeAll } = useProductFilters()
    const [openFacetId, setOpenFacetId] = useState(null)

    const handleFacetToggle = (facetId) => {
        // If clicking the same facet that's open, close it. Otherwise, open the new one.
        setOpenFacetId(openFacetId === facetId ? null : facetId)
    }

    const handleClearAll = () => {
        removeAll()
        // Close all facets
        setOpenFacetId(null)
        // Close the sidebar by unchecking the toggle
        const toggleCheckbox = document.getElementById(toggleButtonId)
        if (toggleCheckbox) {
            toggleCheckbox.checked = false
        }
    }

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
                class="ns-sidebar-wrapper ns-d-none ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto ns-d-flex ns-flex-column">
                    <div class="ns-sidebar-header ns-justify-content-center ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="ns-font-bold ns-font-5 ns-color-black">Filters</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu ns-flex-1 ns-overflow-y-auto">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet
                                            key={facet.id}
                                            facet={facet}
                                            isOpen={openFacetId === facet.id}
                                            onToggle={handleFacetToggle}
                                        />
                                    case "stats":
                                        return <RangeFacet
                                            key={facet.id}
                                            facet={facet}
                                            isOpen={openFacetId === facet.id}
                                            onToggle={handleFacetToggle}
                                        />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-sidebar-footer ns-d-flex ns-p-4 ns-d-block ns-d-md-none">
                        <button
                            className="ns-btn ns-btn-hollow ns-mr-2"
                            onClick={handleClearAll}
                            style="width: calc(50% - 4.5px);"
                        >
                            Clear all
                        </button>
                        <label
                            className="ns-btn ns-btn-primary"
                            for={toggleButtonId}
                            style="width: calc(50% - 4.5px); margin: 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center;"
                        >
                            Apply
                        </label>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
